import { createRoot } from "react-dom/client"

import { sentryDataCollection } from "@forento/core/utilities/sentry"
import "@forento/ui/assets/rich-content.css"

import "~/assets/styles.css"

import App from "./app"

if (!CONFIG.isDevelopment) {
	import("@sentry/react").then(Sentry => {
		Sentry.init({
			dsn: "https://b2feb3c018c2d8ac5ccd5ad7bc18398c@o794413.ingest.us.sentry.io/4509683511721984",
			release: CONFIG.release || undefined,
			dataCollection: sentryDataCollection,
			replaysSessionSampleRate: 0,
			replaysOnErrorSampleRate: 0.1,
			tracesSampleRate: 0.01,
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration({
					beforeErrorSampling(event) {
						const error = event.exception?.values?.[0].value
						if (error?.includes("Failed to fetch")) return false
						return true
					},
				}),
			],
		})
	})
}

createRoot(document.getElementById("root")!).render(<App />)
